import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Int32 from "bs-platform/lib/es6/int32.js";
import * as Int64 from "bs-platform/lib/es6/int64.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Js_dict from "bs-platform/lib/es6/js_dict.js";
import * as Js_json from "bs-platform/lib/es6/js_json.js";
import * as Caml_obj from "bs-platform/lib/es6/caml_obj.js";
import * as Belt_List from "bs-platform/lib/es6/belt_List.js";
import * as Caml_format from "bs-platform/lib/es6/caml_format.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Json_encode from "@glennsl/bs-json/src/Json_encode.bs.js";
import * as Caml_js_exceptions from "bs-platform/lib/es6/caml_js_exceptions.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";
var Json = {};

function Make(Param) {
  var normalize = function normalize(json) {
    var type_;

    try {
      type_ = Json_decode.at(
      /* :: */
      [Param.type_field_name,
      /* [] */
      0], Json_decode.string)(json);
    } catch (raw_exn) {
      var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);

      if (exn[0] === Caml_builtin_exceptions.invalid_argument) {
        return json;
      } else {
        throw exn;
      }
    }

    return (
      /* tuple */
      [type_, json]
    );
  };

  var restore = function restore(json) {
    var match = Js_json.classify(json);

    if (typeof match === "number" || match.tag !==
    /* JSONArray */
    3) {
      return json;
    } else {
      var match$1 = match[0];

      if (match$1.length !== 2) {
        return json;
      } else {
        var v = match$1[0];
        var o = match$1[1];

        if (typeof v === "string") {
          var match$2 = Js_json.classify(o);

          if (typeof match$2 === "number" || match$2.tag !==
          /* JSONObject */
          2) {
            return json;
          } else {
            var obj = match$2[0];
            obj[Param.type_field_name] = v;
            return obj;
          }
        } else {
          return json;
        }
      }
    }
  };

  return {
    normalize: normalize,
    restore: restore
  };
}

var type_field_name = "type";
var Default_param = {
  type_field_name: type_field_name
};

function normalize(json) {
  var type_;

  try {
    type_ = Json_decode.at(
    /* :: */
    [type_field_name,
    /* [] */
    0], Json_decode.string)(json);
  } catch (raw_exn) {
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);

    if (exn[0] === Caml_builtin_exceptions.invalid_argument) {
      return json;
    } else {
      throw exn;
    }
  }

  return (
    /* tuple */
    [type_, json]
  );
}

function restore(json) {
  var match = Js_json.classify(json);

  if (typeof match === "number" || match.tag !==
  /* JSONArray */
  3) {
    return json;
  } else {
    var match$1 = match[0];

    if (match$1.length !== 2) {
      return json;
    } else {
      var v = match$1[0];
      var o = match$1[1];

      if (typeof v === "string") {
        var match$2 = Js_json.classify(o);

        if (typeof match$2 === "number" || match$2.tag !==
        /* JSONObject */
        2) {
          return json;
        } else {
          var obj = match$2[0];
          obj[type_field_name] = v;
          return obj;
        }
      } else {
        return json;
      }
    }
  }
}

function make(f) {
  return f;
}

function encode(f, x) {
  return Curry._1(f, x);
}

function unit(param) {
  return null;
}

var int32 = Int32.to_string;
var int64 = Int64.to_string;

function list(encode, l) {
  return Json_encode.array(encode, Belt_List.toArray(l));
}

function field($$default, encode, name, data) {
  return (
    /* F */
    [
    /* Required */
    Block.__(1, [{
      name: name,
      data: data,
      encode: encode
    }, $$default])]
  );
}

function field_o($$default, encode, name, data) {
  return (
    /* F */
    [
    /* Optional */
    Block.__(0, [{
      name: name,
      data: data,
      encode: encode
    }, $$default])]
  );
}

function obj(fields) {
  return Json_encode.object_(List.fold_left(function (acc, param) {
    var f = param[0];

    if (f.tag) {
      var match = f[1];
      var match$1 = f[0];
      var encode = match$1.encode;
      var data = match$1.data;
      var name = match$1.name;

      if (match !== undefined && Caml_obj.caml_equal(Caml_option.valFromOption(match), data)) {
        return acc;
      } else {
        return (
          /* :: */
          [
          /* tuple */
          [name, Curry._1(encode, data)], acc]
        );
      }
    } else {
      var $$default = f[1];
      var match$2 = f[0];
      var encode$1 = match$2.encode;
      var data$1 = match$2.data;
      var name$1 = match$2.name;

      if (data$1 !== undefined) {
        var s = Caml_option.valFromOption(data$1);

        if ($$default !== undefined && Caml_obj.caml_equal(s, Caml_option.valFromOption($$default))) {
          return acc;
        } else {
          return (
            /* :: */
            [
            /* tuple */
            [name$1, Curry._1(encode$1, s)], acc]
          );
        }
      } else {
        return acc;
      }
    }
  },
  /* [] */
  0, fields));
}

function tuple1(f, x) {
  return (
    /* array */
    [Curry._1(f, x)]
  );
}

function contramap(f, g, b) {
  return Curry._1(g, Curry._1(f, b));
}

function constr0(prim) {
  return prim;
}

function constr1(s, f, x) {
  return Json_encode.pair(function (prim) {
    return prim;
  }, f,
  /* tuple */
  [s, x]);
}

function option_as_constr(f, param) {
  if (param !== undefined) {
    return Json_encode.pair(function (prim) {
      return prim;
    }, f,
    /* tuple */
    ["Some", Caml_option.valFromOption(param)]);
  } else {
    return "None";
  }
}

function adapter(restore, writer, x) {
  return Curry._1(restore, Curry._1(writer, x));
}

function make$1(f) {
  return f;
}

function decode(f, json) {
  return Curry._1(f, json);
}

function unit$1(j) {
  if (j === null) {
    return (
      /* () */
      0
    );
  } else {
    throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
    /* Format */
    [
    /* String_literal */
    Block.__(11, ["Expected null, got ",
    /* String */
    Block.__(2, [
    /* No_padding */
    0,
    /* End_of_format */
    0])]), "Expected null, got %s"]), JSON.stringify(j))];
  }
}

function int32$1(j) {
  return Caml_format.caml_int32_of_string(Json_decode.string(j));
}

function int64$1(j) {
  return Caml_format.caml_int64_of_string(Json_decode.string(j));
}

function list$1(decode, json) {
  return Belt_List.fromArray(Json_decode.array(decode, json));
}

function obj_array(f, json) {
  return Js_dict.entries(Json_decode.dict(f, json));
}

function obj_list(f, json) {
  return $$Array.to_list(Js_dict.entries(Json_decode.dict(f, json)));
}

function nullable(decode, json) {
  if (json === null) {
    return;
  } else {
    return Caml_option.some(Curry._1(decode, json));
  }
}

function fieldOptional(key, decode, json) {
  if (typeof json === "object" && !Array.isArray(json) && json !== null) {
    var match = Js_dict.get(json, key);

    if (match !== undefined) {
      try {
        return Caml_option.some(Curry._1(decode, Caml_option.valFromOption(match)));
      } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);

        if (exn[0] === Json_decode.DecodeError) {
          throw [Json_decode.DecodeError, exn[1] + ("\n\tat field '" + (key + "'"))];
        }

        throw exn;
      }
    } else {
      return;
    }
  } else {
    throw [Json_decode.DecodeError, "Expected object, got " + JSON.stringify(json)];
  }
}

function fieldDefault(s, $$default, f) {
  return Curry._2(Json_decode.map, function (param) {
    if (param !== undefined) {
      return Caml_option.valFromOption(param);
    } else {
      return $$default;
    }
  }, function (param) {
    return fieldOptional(s, f, param);
  });
}

function tuple1$1(f, x) {
  if (Array.isArray(x)) {
    var length = x.length;

    if (length === 1) {
      try {
        return Curry._1(f, x[0]);
      } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);

        if (exn[0] === Json_decode.DecodeError) {
          throw [Json_decode.DecodeError, exn[1] + "\n\tin tuple1"];
        }

        throw exn;
      }
    } else {
      throw [Json_decode.DecodeError, "Expected array of length 1, got array of length " + (String(length) + "")];
    }
  } else {
    throw [Json_decode.DecodeError, "Expected array, got " + JSON.stringify(x)];
  }
}

function $$enum(l) {
  var constr0 = function constr0(x) {
    var s = Json_decode.string(x);
    var val;

    try {
      val = List.assoc(s, l);
    } catch (exn) {
      if (exn === Caml_builtin_exceptions.not_found) {
        throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["unknown constructor ",
        /* Caml_string */
        Block.__(3, [
        /* No_padding */
        0,
        /* End_of_format */
        0])]), "unknown constructor %S"]), s)];
      }

      throw exn;
    }

    if (val[0] >= 427938126) {
      throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["constructor ",
      /* Caml_string */
      Block.__(3, [
      /* No_padding */
      0,
      /* String_literal */
      Block.__(11, [" expects arguments",
      /* End_of_format */
      0])])]), "constructor %S expects arguments"]), s)];
    }

    return val[1];
  };

  var constr = function constr(x) {
    var match = Json_decode.pair(Json_decode.string, function (x) {
      return x;
    }, x);
    var s = match[0];
    var val;

    try {
      val = List.assoc(s, l);
    } catch (exn) {
      if (exn === Caml_builtin_exceptions.not_found) {
        throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["unknown constructor ",
        /* Caml_string */
        Block.__(3, [
        /* No_padding */
        0,
        /* End_of_format */
        0])]), "unknown constructor %S"]), s)];
      }

      throw exn;
    }

    if (val[0] >= 427938126) {
      return Curry._1(val[1], match[1]);
    } else {
      throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["constructor ",
      /* Caml_string */
      Block.__(3, [
      /* No_padding */
      0,
      /* String_literal */
      Block.__(11, [" doesn't expect arguments",
      /* End_of_format */
      0])])]), "constructor %S doesn't expect arguments"]), s)];
    }
  };

  return Json_decode.either(constr, constr0);
}

function option_as_constr$1(f) {
  return Json_decode.either(function (x) {
    if (Json_decode.string(x) === "None") {
      return;
    } else {
      throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["Expected None, got ",
      /* String */
      Block.__(2, [
      /* No_padding */
      0,
      /* End_of_format */
      0])]), "Expected None, got %s"]), JSON.stringify(x))];
    }
  }, function (x) {
    var match = Json_decode.pair(Json_decode.string, f, x);

    if (match[0] === "Some") {
      return Caml_option.some(match[1]);
    } else {
      throw [Json_decode.DecodeError, Curry._1(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["Expected Some _, got ",
      /* String */
      Block.__(2, [
      /* No_padding */
      0,
      /* End_of_format */
      0])]), "Expected Some _, got %s"]), JSON.stringify(x))];
    }
  });
}

function adapter$1(normalize, reader, json) {
  return Curry._1(reader, Curry._1(normalize, json));
}

var Json_adapter = {
  Type_field: {
    Default_param: Default_param,
    normalize: normalize,
    restore: restore,
    Make: Make
  }
};

function Encode_string(prim) {
  return prim;
}

function Encode_float(prim) {
  return prim;
}

function Encode_int(prim) {
  return prim;
}

function Encode_bool(prim) {
  return prim;
}

var Encode = {
  make: make,
  encode: encode,
  unit: unit,
  string: Encode_string,
  $$float: Encode_float,
  $$int: Encode_int,
  bool: Encode_bool,
  $$char: Json_encode.$$char,
  list: list,
  array: Json_encode.array,
  int32: int32,
  int64: int64,
  field: field,
  field_o: field_o,
  obj: obj,
  tuple1: tuple1,
  tuple2: Json_encode.tuple2,
  tuple3: Json_encode.tuple3,
  tuple4: Json_encode.tuple4,
  constr0: constr0,
  constr1: constr1,
  contramap: contramap,
  nullable: Json_encode.nullable,
  option_as_constr: option_as_constr,
  adapter: adapter
};
var Decode = {
  make: make$1,
  decode: decode,
  unit: unit$1,
  bool: Json_decode.bool,
  $$int: Json_decode.$$int,
  $$float: Json_decode.$$float,
  $$char: Json_decode.$$char,
  string: Json_decode.string,
  int32: int32$1,
  int64: int64$1,
  optional: Json_decode.optional,
  list: list$1,
  array: Json_decode.array,
  obj_list: obj_list,
  obj_array: obj_array,
  field: Json_decode.field,
  fieldDefault: fieldDefault,
  fieldOptional: fieldOptional,
  map: Json_decode.map,
  tuple1: tuple1$1,
  tuple2: Json_decode.tuple2,
  tuple3: Json_decode.tuple3,
  tuple4: Json_decode.tuple4,
  $$enum: $$enum,
  nullable: nullable,
  option_as_constr: option_as_constr$1,
  adapter: adapter$1
};
export { Json, Json_adapter, Encode, Decode };
/* No side effect */